export const DEFAULT_PLAINTEXT_TEMPLATE = "{{message.text}}";
export const DEFAULT_HTML_THREADED_TEMPLATE = `<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Transitional//EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd">
<html xmlns="http://www.w3.org/1999/xhtml">
	<head>
		<meta http-equiv="Content-Type" content="text/html; charset=utf-8" />
		<title>{{ticket.subject}}</title>
	</head>
	<body>
	{{#ticket.cc.0}}
	<strong>In the loop:</strong> {{#ticket.cc}}{{email}} {{/ticket.cc}}<br/>
	<br/>
	{{/ticket.cc.0}}
	<div>{{{message.html}}}</div>
	{{#events}}
	<hr />
	<div>
		<em>On {{date.ownerUS}} {{#author.isRule}}agent{{/author.isRule}}{{#author.isClient}}{{author.email}}{{/author.isClient}}{{#author.isAgent}}{{#author.name}}{{.}}{{/author.name}}{{^author.name}}{{author.email}}{{/author.name}}{{/author.isAgent}} wrote:</em>
		<br /><br />
		{{{message.textBr}}}
		{{#attachments.0}}
		<br />
		<em>Attachments:</em>
		<ul>
		{{#attachments}}
		<li><a href="{{url}}">{{name}}</a></li>
		{{/attachments}}
		</ul>
		{{/attachments.0}}
	</div>
	{{/events}}
	</body>
</html>`;

export const DEFAULT_HTML_TEMPLATE = `<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Transitional//EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd">
<html xmlns="http://www.w3.org/1999/xhtml">
	<head>
		<meta http-equiv="Content-Type" content="text/html; charset=utf-8" />
		<title>{{ticket.subject}}</title>
	</head>
	<body>
		{{#ticket.cc.0}}
		<strong>In the loop:</strong> {{#ticket.cc}}{{email}} {{/ticket.cc}}<br/>
		<br/>
		{{/ticket.cc.0}}
		<div>{{{message.html}}}</div>
	</body>
</html>`;

export const DUMMY_TEMPLATE_ID = "00000000-0000-4000-0000-000000000000";
